import {ready} from '../main/utils';

import 'jquery-visible';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import MoreCaseStudies from './more-case-studies';
import loadCaseStudiesCarousel from './case-studies-carousel';

const loadCaseStudies = () => {
  if (document.querySelector('.case-studies')) {
    new Vue({
      el: '.case-studies',
      comments: true,
      components: {
        MoreCaseStudies
      },
      router
    });
  }
};

ready(() => {
  loadCaseStudies();
  loadCaseStudiesCarousel();
});
